import React, {  useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Modal from "./Modal";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const UserList = () => 
{           
            let [userTypeId, setUserTypeId]= useState(0);
            let [suserName , setSuserName]= useState('');   
            const fileType ="xlsx";
            const tableRef = useRef(null);
            const API_URL=aPIURL();
            const AUTH_URL= auTHURL();
                        
            const [post, setPost] = useState([]);
            const [order, setOrder] = useState("ASC");
            const [number, setNumber] = useState(1); // No of pages
            const [postPerPage] = useState(10);
            
             useEffect(() => {
       
                FillGrid();// Zero for All
                
            }, []);
              
              const lastPost = number * postPerPage;
              const firstPost = lastPost - postPerPage;
              const currentPost = post.slice(firstPost, lastPost);
              const PageCount = Math.ceil(post.length / postPerPage);
  
  const ChangePage = ({ selected }) => {
        
                setNumber(selected+1);
   };

const sorting=(col)=>
 {
          
            try
            {
              if(order==="ASC")
              {
                      const sorted=[...post].sort((a,b)=>
                      a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
                      );
                      setPost(sorted);
                      setOrder("DSC");
              }
              if(order==="DSC")
              {
                      const sorted=[...post].sort((a,b)=>
                      a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
                      );
                      setPost(sorted);
                      setOrder("ASC");
              }
            }
            catch(error) 
            {
              console.log(error.message);
            }                      
          }

const FillGrid=()=>
{
    //alert("FillGrid");
    const curls = API_URL + `Users`;
    //alert(curls);
    setPost([]);
    axios.get(curls).then(response => {                       
    setPost(response.data);
    //console.log("--------------------------------------------------User List-----------------------------------------------------");  
    console.log(response.data);  
     }).catch(function(error){console.log(error.message);});
}

const FilterGrid=()=>
{
      const fcurls=API_URL+`Users/${suserName}/${userTypeId}`; 
      //alert(fcurls);          
      setPost([]);
      axios.get(fcurls).then(response => {                       
      //console.log(response.data); 
      setPost(response.data); 

     }).catch(function(error){console.log(error.message);});
}
const ResetPage=()=>
{
            FillGrid(0);
            setSuserName('');
}

const ActivateUser = (username) => {
            
       const curls = AUTH_URL+`ActivateUser/?userName=${username}`;             
       axios.post(curls).then(response => 
        {       
             console.log(response.data); 
             if(response.data.statusCode===1)   
             {
                   toast.success("User Activated Successfully.");
                   FillGrid(0);
             }
             else
             {
                   toast.error(response.data.message);
             }
    }
).catch(function (error) 
        {
             console.log(error.message);          
        });   
}  
const DeactivateUser=  (username) => {
          
   if(window.confirm('Are you sure to deactivate this user?'))
   {
       const curls = AUTH_URL+`DeactivateUser/?userName=${username}`;             
       axios.post(curls).then(response => 
        {       
             console.log(response.data); 
             if(response.data.statusCode===1)   
             {
                   toast.success("User Deactivated Successfully.");
                   FillGrid(0);
             }
             else
             {
                   toast.error(response.data.message);
             }                                                                  
        }
        ).catch(function (error) 
        {
             console.log(error.message);          
        });   
      }
      else 
      {
                  toast.error('Operation canceled by the user.');
      }
}  


const styles = {
    headsection: {
        backgroundColor:"black", color:"white",textAlign:"center"
    },
    wrapper: {
      textAlign: "center",
      margin: "0 auto",
      marginTop: "50px"
    }
  }
    
  const exportStatus = e => {
 
    const usertypevalue = e.target.value;
    setUserTypeId(e.target.value);    
    const fcurls=API_URL+`Users/0/${usertypevalue}`;       
    setPost([]);
    axios.get(fcurls).then(response => {                       
    setPost(response.data); 

     }).catch(function(error){console.log(error.message);});
  }

  const exportToCSV=()=>
    {
      const newPost = post.map(({ isChecked,parentDetails, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:10},
          {wch:20},
          {wch:10},
          {wch:20},
          {wch:20},
          {wch:20},    
          {wch:10}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','CUSTOMER NAME','USERNAME','EMAIL','USER ROLE']];
      const wb={Sheets:{Users:ws},SheetNames:["Users"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtUsersReport"+".xlsx");
     }

const DUserNamechangeHandler=(e)=>
{
     setSuserName(e.target.value)
}

const exportDownload = e => 
{  
    const value = e.target.value; 
    //alert(value)

  if(value=="Excel")
  {
        exportToCSV();   
      // onDownload();
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}
const handlePrint = useReactToPrint({
  documentTitle: "User Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

  return (
    <>   
         <div className="top-bar clearfix">
        <div className="row">
       
        <div className="col-md-4">
        <h2> Users </h2>           
        </div>
          <div className="col-md-8 text-right">
                  
          <select onChange={exportStatus} className="btn btn-primary" name="Export">
          <option value={"0"}>All</option>    
          <option value={"1"}>Acivated</option>  
          <option value={"2"}>Deactivated</option>   
           </select> 
          <select onChange={exportDownload} className="btn btn-primary" name="Download" >
          <option value={"Download"}>Download</option>    
          <option value={"Excel"}>Excel</option>    
          <option value={"PDF"}>PDF</option>                      
          </select>
          </div>
        </div>
      </div>    
      <div className="container-fluid p-3">
      <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
  <div class="row align-items-end">  
  <div class="col-sm-3 col-lg-2">User Name <input type="text" class="form-control" tabindex="1" id="txtUserName"   maxlength="30" value={suserName} onChange={DUserNamechangeHandler}/>
  </div>
     
  <div class="col-sm-4 col-lg-2">
  <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
  <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetPage}>Reset </button></div>
  <div class="col-sm-3 col-lg-2"> </div>
  </div>    
  </div></div>
  <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body p-0">
    <table ref={tableRef}  id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
    <thead>
    <tr><th width="5%" style={{textAlign:"center"}}>S.No.</th>
    <th width="30%" onClick={()=>sorting("name") } style={{textAlign:"center","cursor": "pointer"}}>CUSTOMER NAME &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="25%" onClick={()=>sorting("userName") } style={{textAlign:"center","cursor": "pointer"}}>USER NAME &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="20%" onClick={()=>sorting("email") } style={{textAlign:"center","cursor": "pointer"}}>EMAIL &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="15%" onClick={()=>sorting("role") } style={{textAlign:"center","cursor": "pointer"}} >ROLE &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="5%" style={{textAlign:"center"}}>Action </th>
    </tr>
    </thead>
    <tbody>
    {currentPost.map((devdata) => {
    return (
    <tr key={devdata.id}>
    <td style={{textAlign:"center"}}>{devdata.id}</td>
    <td >{devdata.name}</td>
    <td >{devdata.userName}</td>
    <td >{devdata.email}</td>
    <td >{devdata.role} </td>
    <td style={{textAlign:"center", fontSize:"16px"}}>
    <i class="fas fa-toggle-on"  className={devdata.isChecked.toString()==="true"?"display:none":"display:block  fas fa-toggle-on"}  onClick={() => DeactivateUser(devdata.userName)}
    style={{ color:"green", cursor:'pointer'}} title="Deactivate User"></i>
    <i className={devdata.isChecked.toString()==="false"?"display:none":"display:block  fas fa-toggle-off"} onClick={() => ActivateUser(devdata.userName)}  
    style={{ color:"#FD0691", cursor:'pointer'}} title="Activate User"></i>                    
    </td></tr>
    ); })}
    </tbody>
    </table>
    <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount}  onPageChange={ChangePage}  disableInitialCallback={true}
    initialPage={0}  containerClassName={'pagination justify-content-end'} pageClassName={'page-item'} pageLinkClassName={'page-link'}  previousClassName={'page-item'}
    previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}  breakClassName={'page-item'}  breakLinkClassName={'page-link'}  
    activeClassName={'active'}></ReactPaginate>       
    </div> </div></div></div>
    <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>       
    </>
    );
    }   
export default UserList;
